const USER_PHOTO =
    Object.freeze(
        {
            MAX_FILE_SIZE: 30 * 1024 * 1024,
            BASE_URL: process.env.MIX_DO_SPACES_PUBLIC_URL
                + process.env.MIX_IMAGE_PATH
                + '/images/photos/',
            GALLERY_BASE_URL: process.env.MIX_DO_SPACES_PUBLIC_URL
                + process.env.MIX_IMAGE_PATH
                + '/galleries/',
            NO_PHOTO_SEARCH_URL: process.env.MIX_IMG_SEARCH_NO_PHOTO || '/images/escort_no_photo.jpg',
            NO_PHOTO_SEARCH_URL_SMALL: process.env.MIX_IMG_SEARCH_NO_PHOTO_SMALL || '/images/escort_no_photo_small.jpg',
            EXPLICIT_PHOTO_PLACEHOLDER: '/images/explicit_photo_placeholder_v2.jpg',
            EXPLICIT_VIDEO_PLACEHOLDER: '/images/videofsk.png',
            EXPLICIT_PHOTO_PLACEHOLDER_SMALL: '/images/explicit_photo_placeholder_small_v2.jpg',
            EXPLICIT_VIDEO_PLACEHOLDER_SMALL: '/images/videofsk_small.png',
            ADVERT_URL: process.env.MIX_DO_SPACES_PUBLIC_URL + process.env.MIX_IMAGE_PATH,
            PROFILE_BANNER_URL: process.env.MIX_DO_SPACES_PUBLIC_URL + process.env.MIX_IMAGE_PATH + '/images/profile_banners/',
            SYSTEM_MESSAGE_PHOTO: '/images/messaging-team_erobella.svg',
        }
    );

export default USER_PHOTO;
